export type VatRate = {
  code: string;
  rates: Rate[];
  calculationRule: CalculationRule;
};

type CalculationRule = {
  formulaFromWithoutVat: string;
  formulaFromWithVat: string;
  roundType: string;
  roundScale: number;
  roundStep: number;
  activeFrom: string;
};

export type Rate = {
  type: string;
  name: string;
  rate: string;
  activeFrom: string;
};

export type GetVatRatesApiResponse = /** status 200  */ VatRate[];
export type GetVatRatesApiArg = void;
export type GetVatRatesForCountryApiArg = {date: string; country: string};
export type GetVatRatesForCountryApiResponse = VatRate;
